import React, { useEffect } from 'react';
// import { useRive } from '@rive-app/react-canvas';
import overview from '../../assets/qfc_overview.png';
import overviewMobile from '../../assets/qfc_overview_mobile.png';
import suppliers from '../../assets/qfc_suppliers.png';
import suppliersMobile from '../../assets/qfc_suppliers_mobile.png';
import check from '../../assets/qfc_demo_check.svg';
import ai from '../../assets/ai_icon.svg';
import haccp from '../../assets/qfc_haccp.png';
import haccpMobile from '../../assets/qfc_haccp_mobile.png';
import routine from '../../assets/qfc_rutin.png';
import routineMobile from '../../assets/qfc_rutin_mobile.png';
import stats from '../../assets/qfc_stats_desktop.png';
import statsMobile from '../../assets/qfc_stats_mobile.png';
import { useTranslation } from 'react-i18next';
import FadeInSection from '../../animation/fadein_onscroll';
import './features.css';

const Features = () => {
  const { t } = useTranslation();
  useEffect(() => {
    const handleScroll = () => {
      const images = document.querySelectorAll('.parallax img');
      images.forEach(image => {
        const rect = image.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        if (rect.top <= windowHeight && rect.bottom >= 0) {
          const offset = (windowHeight - rect.top) * 0.15; // Adjust speed here
          const scale = 1 + (windowHeight - rect.top) * 0.00018; // Adjust scaling factor here

          image.style.transform = `translateY(${offset}px) scale(${scale})`;
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

//   const { RiveComponent } = useRive({
//     src: '../../assets/task_done.riv',
//     autoplay: true,
//   });

  return (
    <div>
      <div className="section parallax" tabindex="3">
        <div className="image-container">
          <img src={overview} alt="Översikt" className="feature-image desktop" />
          <img src={overviewMobile} alt="Översikt" className="feature-image mobile" />
        </div>
        <div className="text-container">
          <div className="text-content">
            <h2>{t('features.feature1.title')}</h2>
            <p>{t('features.feature1.description')}</p>
          </div>
        </div>
      </div>

      <div className="section reverse parallax"tabindex="3">
        <div className="text-container text-reverse">
          <div className="text-content">

			      <p className="text-content-tag">{t('common.haccp')}</p>
            <h2>{t('features.feature2.title')}
            <img src={ai} alt="{t('features.feature1.title')}" className="ai-icon"></img> </h2>
            <p>{t('features.feature2.description')}</p>
          </div>
        </div>
        <div className="image-container reverse">
          <img src={haccp} alt="HACCP" className="feature-image desktop" />
          <img src={haccpMobile} alt="HACCP" className="feature-image mobile" />
        </div>
      </div>

      <FadeInSection>
      <div className="section centered parallax stats-section" tabindex="3">
        <div className="text-container stats-image-container">
          <img src={stats} alt="Stats" className="feature-image desktop stats-image" />
          <img src={statsMobile} alt="Stats" className="feature-image mobile stats-image" />
        </div>
        <div className="text-container centered stats-container">
          <div className="">
            <h2>{t('features.feature6.title')}</h2>
            <p>{t('features.feature6.description')}</p>
          </div>
        </div>
      </div>
      </FadeInSection>

	    <div className="section parallax"tabindex="3">
        <div className="image-container">
          <img src={routine} alt="Rutiner" className="feature-image desktop" />
          <img src={routineMobile} alt="Rutiner" className="feature-image mobile" />
        </div>
        <div className="text-container">
          <div className="text-content">
          <h2>{t('features.feature3.title')} <img src={ai} alt="{t('features.feature1.title')}" className="ai-icon"></img></h2>
          <p>{t('features.feature3.description')}</p>
          </div>
        </div>
      </div>

      <div className="section reverse parallax"tabindex="3">
        <div className="text-container text-reverse">
          <div className="text-content">
            <h2>{t('features.feature4.title')}</h2>
            <p>{t('features.feature4.description')}</p>
          </div>
        </div>
        <div className="image-container reverse">
          <img src={suppliers} alt="Leverantörer" className="feature-image desktop" />
          <img src={suppliersMobile} alt="Leverantörer" className="feature-image mobile" />
        </div>
      </div>
	
	  <FadeInSection>
		<div className="Section small centered" tabindex="3">
			<div className="text-container centered check">
        <div className="text-content centered">
          <h2>{t('features.feature5.title')}</h2>
            <p>{t('features.feature5.description')}</p>
        </div>
				<img src={check} alt="Bock" className="feature-image check" />
			</div>
		</div>
	  </FadeInSection>

    </div>
  );
};

export default Features;
